<script>
	import { createEventDispatcher } from "svelte";
	import {Types} from './song.js'

	const dispatch = createEventDispatcher();

	export let songs = [];
	export let genres = [];

	let byGenres = true;

	let learning = true;
	let key = true;
	let artist = false;
	let book = false;

	function songToText(s) {
		var t = s.name;
		if (artist && s.artist) {
			t += " (" + s.artist + ")"
		}
		if (key && s.key) {
			t += " v " + s.key;
		}
		if (book && s.books) {
			t += " (" + s.books + ")";
		}
		return t;
	}

	function filterSongs(list) {
		return list.filter(s => (learning && s.type == Types.LEARNING) || s.type == Types.DONE);
	}

	function mergeArtist(acc, song) {
		const key = song.artist ?? "";
		const group = acc[key] ?? [];
		return { ...acc, [key]: [...group, song] };
	}

	function dumpArtistSongs(artist, songsList, list) {
		if (songsList.length == 1) {
			let str = "\t";
			if (artist)
				str += artist + " - ";
			str += songToText(songsList[0]);
			list.push(str);
			return true;
		}
		let pref = "";
		if (artist.length) {
			list.push("\t" + artist);
			pref = " - "
		}
		for (const song of songsList) {
			list.push("\t" + pref + songToText(song));
		}
		return false;
	}

	function genreSort() {
		let ret = [];
		for (const it of genres) {
			let filtered = filterSongs(it[1]);
			if (!filtered.length)
				continue;

			ret.push("");
			let genre = it[0];
			if (genre.length)
				ret.push(genre);

			let byArtist = Object.entries(filtered.reduce(mergeArtist, {}));
			byArtist.sort((a, b) => b[1].length - a[1].length);

			let inSingles = false;
			for (const [art, songList] of byArtist) {
				console.log(art, songList);
				if (!inSingles)
					ret.push("");

				inSingles = dumpArtistSongs(art, songList, ret);
			}
		}
		return ret;
	}

	function exportList() {
		if (byGenres) {
			return genreSort(genres);
		}
		let list = filterSongs(songs)
			.map(s => songToText(s));
		list.sort((a, b) => a.localeCompare(b, 'cz'));
		return list;
	}

	$: names = exportList(songs, byGenres, learning, key, artist, book);
	$: json = JSON.stringify(songs);

	function getList() {
		let value = document.getElementById("area").value;
		return JSON.parse(value);
	}

	function importData() {
		let impList = getList();
		if (!impList || !impList.length) {
			return;
		}
		if (confirm("detekováno písní: " + impList.length + "\nOPRAVDU CHCEŠ NAHRADIT SEZNAM PÍSNIČEK?")) {
			dispatch("replaceSongs", impList);
		}
	}
</script>

<style>
	.expimp {
		margin-left: 3em;
	}

	#jsonexp * {
		float: "left";
	}

	ul {
		padding-left: 0;
	}
</style>

<div class="inblock frame">
<div style="font-weight:bold">vypsat písničky</div>
<ul>
	<li><label><input type=checkbox bind:checked={byGenres}> řadit do kategorií</label>
	<li><label><input type=checkbox bind:checked={learning}> včetně učení</label>
	<li><label><input type=checkbox bind:checked={key}> včetně tóniny</label>
	<li><label><input type=checkbox bind:checked={artist}> včetně autora</label>
	<li><label><input type=checkbox bind:checked={book}> včetně zpěvníku</label>
</ul>
</div>

<div id="jsonexp" class="inblock frame expimp">
	<textarea id="area" class="item" rows="5" cols="50">{json}</textarea>
	<br>
	<button class="item" on:click={(e) => importData()}>vložit data</button>
</div>
<pre>
	{#each names as song}
		{song + "\n"}
	{/each}
</pre>
